export const getNavbar = async (locale: string) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/items/navbar_translations?fields=*,menu_items.nav_menu_item_translations_id.*,menu_items.nav_menu_item_translations_id.sub_nav_menu.item.*,menu_items.nav_menu_item_translations_id.sub_nav_menu.item.sub_menu_items.sub_menu_item_translations_id.*,menu_items.nav_menu_item_translations_id.sub_nav_menu.item.sub_categories.*,menu_items.nav_menu_item_translations_id.sub_nav_menu.item.sub_categories.sub_sub_categories.*&filter={"languages_code" : {"_eq" : "${locale}"}}`,
      {
        cache: 'no-store',
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data.data[0];
    }
    return null;
  } catch (error) {
    console.log(error);
  }
};

export const getNavbarMinimal = async (locale: string) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/items/navbar_translations?fields=top_message,top_info_text,auth_enabled,menu_items.nav_menu_item_translations_id.title,menu_items.nav_menu_item_translations_id.short_title,menu_items.nav_menu_item_translations_id.type,menu_items.nav_menu_item_translations_id.is_singleton,menu_items.nav_menu_item_translations_id.singleton_path&filter={"languages_code" : {"_eq" : "${locale}"}}`,
      {
        cache: 'no-store',
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data.data[0];
    }
    return null;
  } catch (error) {
    console.log(error);
  }
};
